import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { SharedModule } from "@app/shared/shared.module";
import { GlobalService } from "@core/services/global.service";
import { EffectsModule } from "@ngrx/effects";
import { TranslateModule } from "@ngx-translate/core";
import { BenefitsComponent } from "./components/benefits/benefits.component";
import { BookADemoComponent } from "./components/book-a-demo/book-a-demo.component";
import { FooterComponent } from "./components/footer/footer.component";
import { MainpageComponent } from "./components/mainpage/mainpage.component";
import { PopoverComponent } from "./components/navbar/components/popover/popover.component";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { LandingFacade } from "./facade/landing.facade";
import { LandingRoutingModule } from "./landing-routing.module";
import { LandingComponent } from "./landing.component";
import { LandingService } from "./services/landing.service";
import { LandingEffect } from "./store/effects/landing.effect";
import { DemoFormComponent } from './components/demo-form/demo-form.component';

@NgModule({
  declarations: [
    LandingComponent,
    NavbarComponent,
    MainpageComponent,
    BookADemoComponent,
    BenefitsComponent,
    FooterComponent,
    PopoverComponent,
    DemoFormComponent,
  ],
  imports: [CommonModule, LandingRoutingModule, TranslateModule, SharedModule, EffectsModule.forFeature([LandingEffect])],
  providers: [LandingFacade, LandingService, GlobalService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LandingModule {}
